import React from 'react';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    Container,
    Message,
    ButtonContainer,
} from './UnidHubOrderDeletePopup.styled';
import { useTranslation } from 'react-i18next';
import AlertCircleWarning from 'src/assets/images/AlertCircleWarning.svg';

const UnidHubOrderDeletePopup = ({ onClose, margin, buttonMargin }) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup
             id="orders-unidhuborderdeletepopup-popup"
                title={t('orders.unidHubOrderDelete.title')}
                onClose={onClose}
                margin={margin}
                imgRightToText={AlertCircleWarning}
                imgRightToTextMarginLeft={'6px'}
                id={'orders-unidHubOrderDeletePopup-popup'}
            >
                <Container>
                    <Message marginTop={'15px'}>
                        {t('orders.unidHubOrderDelete.msg1')} 
                    </Message>
                    <Message marginTop={'30px'}>
                        {t('orders.unidHubOrderDelete.msg2')}
                    </Message>
                    <ButtonContainer buttonMargin={buttonMargin}>
                        <Button
                        id={'orders-unidhuborderdeletepopup-close-button'}
                            show
                            //primary
                            variant={ButtonStyles?.primary}
                            width={'96px'}
                            height={'36px'}
                            margin={'-2px 0px 0px 0px'}
                            fontSize={'14.5px'}
                            borderRadius={'19px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            {t('common.closeUpperCaseButton')}
                        </Button>
                    </ButtonContainer>
                </Container>
            </Popup>
        </>
    );
};

export default UnidHubOrderDeletePopup;
